// Core exports
export * from './core'

// Import widget registrations
import './widgets/schedule'
import './widgets/login'
import './widgets/bookings'
import './widgets/membership'
// New widgets
import './widgets/pricing'
import './widgets/class-types'
import './widgets/instructors'
import './widgets/upcoming-classes'
import './widgets/weekly-schedule'
import './widgets/week-grid'
import './widgets/seasons'
import './widgets/treatments'
import './widgets/rooms'
import './widgets/blog'
import './widgets/testimonials'
import './widgets/contact-info'
import './widgets/contact-form'
import './widgets/newsletter'
import './widgets/gift-cards'
import './widgets/waitlists'
import './widgets/campaign-banner'
import './widgets/klinik-schedule'
import './widgets/retreats'
import './widgets/retreat'
import './widgets/temperature'

// Version
export const VERSION = '1.2.0'

// Log initialization
console.log(`🧘 Yoga Widgets v${VERSION} loaded`)
